/* Shared config for timings that should be used by all animation components as
 * default to have a common alignment and feeling.
 */
export const DURATION = 1000; // milliseconds

export const DELAY_OFFSET = 125; // milliseconds
